import {Constants} from '@article-overview/components/view-constants.js';

export const rebuildUrl = (urlString, pageParam = null) => {
    if (!urlString) return urlString;

    // Parse the URL
    const url = new URL(urlString, window.location.origin);

    // Update page param if provided
    if (pageParam !== null && pageParam !== undefined) {
        url.searchParams.set(Constants.SEARCH_PARAMS_PAGE, pageParam.toString());
    }

    // Rebuild: pathname (force trailing slash) + search params
    let pathname = url.pathname;
    if (pathname.length > 1 && !pathname.endsWith('/')) {
        pathname = pathname + "/"
    }

    const search = url.searchParams.toString();
    return pathname + (search ? `?${search}` : '');
};

export const buildQueryKeyUrl = (urlString, infinite ) => {
    if (!urlString) return urlString;

    const url = new URL(urlString, window.location.origin);

    if (infinite) {
        url.searchParams.delete(Constants.SEARCH_PARAMS_PAGE);
    }
    url.searchParams.delete(Constants.SEARCH_PARAMS_SCROLL_Y);
    url.searchParams.delete(Constants.SEARCH_PARAMS_ANCHOR);
    url.searchParams.delete(Constants.SEARCH_PARAMS_TEASER_ANCHOR);

    let pathname = url.pathname;
    if (pathname.length > 1 && pathname.endsWith('/')) {
        pathname = pathname.slice(0, -1);
    }

    const search = url.searchParams.toString();
    return pathname + (search ? `?${search}` : '');
};
